import { render, staticRenderFns } from "./NLPKeywords.vue?vue&type=template&id=676e16b5&scoped=true&"
import script from "./NLPKeywords.vue?vue&type=script&lang=js&"
export * from "./NLPKeywords.vue?vue&type=script&lang=js&"
import style0 from "./NLPKeywords.vue?vue&type=style&index=0&id=676e16b5&prod&lang=scss&"
import style1 from "./NLPKeywords.vue?vue&type=style&index=1&id=676e16b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e16b5",
  null
  
)

export default component.exports